import { NgTemplateOutlet } from "@angular/common";
import { Component, inject, TemplateRef } from "@angular/core";
import { DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
    selector: "kno2-dialog-footer-host",
    imports: [NgTemplateOutlet],
    template: `
        <ng-container [ngTemplateOutlet]="footer" />
    `
})
export class DialogFooterHostComponent {
    private readonly config = inject(DynamicDialogConfig);
    protected readonly footer = this.config.data?.kno2FooterTemplate as TemplateRef<unknown>;
}
